/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */

define([
	'underscore'
], function(_) {


	/**
	* The singleton class to build the common unique hash id.
	*/
	class UniqueHashIdBuilder {

		/**
		 * API to build unique hash id
		 * @param {string} origin - used to build hash id.
		 * @param {map} idsMap - ids map used to check uniqueness.
		 */
		static createUniqueHashId(origin, idsMap) {
			if (!idsMap) {
				return; // Return if idsMap is not provided
			}

			// Create hash id until no duplicate in idsMap
			let hashId = this._hashCode(origin);
			let i = 0;
			while (idsMap[hashId] || _.values(idsMap).indexOf(hashId) !== -1) {
				hashId = this._hashCode(hashId + i);
				i++;
			}

			return hashId;
		}

		static _hashCode(idStr) {
			let hash = 0, i, chr;
			if (idStr.length === 0) {
				return hash;
			}
			for (i = 0; i < idStr.length; i++) {
				chr   = idStr.charCodeAt(i);
				hash  = ((hash << 5) - hash) + chr;
				hash |= 0; // Convert to 32bit integer
			}
			hash = hash < 0 ? '_'.concat(-hash) : hash;
			return 'id'.concat(hash);
		}
	}
	return UniqueHashIdBuilder;
});
